import CharactersLeftCopySection from './CharactersLeftCopySection';

export default CharactersLeftCopySection;